import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const KEY_STORAGE = 'as_key';
const USER_STORAGE = 'studio_user';

export function getKey() {
  try { return sessionStorage.getItem(KEY_STORAGE) || ''; } catch { return ''; }
}

export function setKey(k) {
  try { sessionStorage.setItem(KEY_STORAGE, k); } catch {}
}

export function getUser() {
  try { return JSON.parse(sessionStorage.getItem(USER_STORAGE) || 'null'); } catch { return null; }
}

export function setUser(u) {
  try { sessionStorage.setItem(USER_STORAGE, JSON.stringify(u)); } catch {}
}

export function logout() {
  try {
    sessionStorage.removeItem(KEY_STORAGE);
    sessionStorage.removeItem(USER_STORAGE);
  } catch {}
}

export function isAdmin() {
  const u = getUser();
  return !!(u && u.role === 'admin');
}

export function RequireAuth({ children }) {
  const loc = useLocation();
  if (!getKey() || !getUser()) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}

export function RequireAdmin({ children }) {
  const loc = useLocation();
  if (!getKey() || !isAdmin()) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}

export function useAuthRefresh() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const onStorage = () => setTick(t => t + 1);
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return tick;
}
